import olMap from 'ol/Map';
import { MapContextMenu } from './MapContextMenu';
import * as olProj from 'ol/proj';
import * as olExtent from 'ol/extent';
import { MapBrowserEvent } from 'ol';
import { Coordinate } from 'ol/coordinate';
import { OSGB, WGS84 } from 'esdm-gridreference';


export interface ILonLat {
    valid: boolean,
    lat: number,
    lon: number
}


export class MapGridRef {

    private invalidGridRef: HTMLElement;    

    public constructor(private map: olMap, private mapContextMenu: MapContextMenu) {
        let self = this;
        this.invalidGridRef = document.getElementById("invalidGridRef");

        //grid ref
        $('#btnGoToGridReference').click(function (event) {            
            let searchTerm = (<string>$("#txtGridRef").val()).trim();
            self.goToGridReference(searchTerm);
        });
        $("#txtGridRef").on("keyup", function (event) {
            event.preventDefault();
            if (event.keyCode === 13) {
                let searchTerm = (<string>$("#txtGridRef").val()).trim();
                self.goToGridReference(searchTerm);
            }
        });

        //lonlat
        $('#btnGoToLonLat').click(function (event) {
            let searchTerm = (<string>$("#txtLonLat").val()).trim();
            self.goToLonLat(searchTerm);
        });
        $("#txtLonLat").on("keyup", function (event) {
            event.preventDefault();
            if (event.keyCode === 13) {
                let searchTerm = (<string>$("#txtLonLat").val()).trim();
                self.goToLonLat(searchTerm);
            }
        });

        this.initContextMenu();
    }


    private initContextMenu = (): void => {
        let items = [
            '-', // this is a separator
            {
                text: `<i class="fa fa-street-view" aria-hidden="true"></i>Get grid reference`,
                callback: this.onGetGridReferenceClick
            }
        ];

        this.mapContextMenu.addItems(items);
    }

    private onGetGridReferenceClick = (event: MapBrowserEvent, map: olMap): void => {
        //Logger.log("onGetGridReferenceClick");

        if (!$("#slide-panel-search").is(':visible')) {
            $("#slide-panel-btn-search").click();
        }
        $("#txtGridRef").focus();

        let coord27700 = olProj.transform(event.coordinate, 'EPSG:3857', 'EPSG:27700');
        $("#txtGridRef").val(this.getGridRef(coord27700));

        let coord4326 = olProj.transform(event.coordinate, 'EPSG:3857', 'EPSG:4326');
        $("#txtLonLat").val(`${coord4326[1].toFixed(6)} ${coord4326[0].toFixed(6)}`);
    }

    private getLonLat = (searchTerm: string): ILonLat => {
        let returnVal: ILonLat = null;

        let parse = function (seperator: string, latLonString: string): ILonLat {
            let latlon = latLonString.split(seperator).filter(function (el) {
                return el != null;
            });
            if (latlon.length === 2 && !isNaN((<any>latlon[0])) && !isNaN((<any>latlon[1]))) {
                //we have two numbers
                return {
                    valid: true,
                    lat: (parseFloat(latlon[0])),
                    lon: (parseFloat(latlon[1]))

                }
            } else {
                return {
                    valid: false,
                    lat: null,
                    lon: null
                }
            }
        };

        //try splitting by space first
        returnVal = parse(" ", searchTerm);

        if (!returnVal.valid) {
            //try comma
            returnVal = parse(",", searchTerm)
        }

        return returnVal
    }

    private goToLonLat = (searchTerm: string): void => {
        let lonlat: ILonLat = this.getLonLat(searchTerm);

        $("#invalidLonlat").hide();

        let coords27700:Coordinate = olProj.transform([lonlat.lon, lonlat.lat], 'EPSG:4326', 'EPSG:27700');

        if (lonlat.valid) {
            //check in uk bounds
            let ukBounds:olExtent.Extent = [0, 0, 700000, 1300000];

            if (!olExtent.containsCoordinate(ukBounds, coords27700)) {
                lonlat.valid = false;
            }
        }

        if (!lonlat.valid) {
            $("#invalidLonlat").show();
            return;
        }

        let coords3857:Coordinate = olProj.transform(coords27700, 'EPSG:27700', 'EPSG:3857');
        this.map.getView().animate({ center: coords3857 }, { zoom: 14 });
    }

    private goToGridReference = (searchTerm: string): void => {
        //if (searchTerm.length < 8) {
        //    invalidGridRef.style.display = 'block';
        //    return;
        //}

        let char: string,
            sheet: string,
            easting: number = null,
            northing: number = null,
            eastingStr: string = "",
            northingStr: string = "",
            processNorthing: boolean,            
            coordLen: number,
            coords: string,
            isValid: boolean = true;

        // use first two chars as sheet
        sheet = searchTerm.substring(0, 2);
        let patternCheckForTwoLetters: RegExp = new RegExp("[A-Za-z]{2}");

        if (patternCheckForTwoLetters.test(sheet)) {
            sheet = sheet.toUpperCase();
            //we have a sheet number, so the x/y coords must have the same number of digits
            //remove all spaces
            coords = searchTerm.replace(/\s/g, '').substring(2);

            if (coords.length >= 4 && (coords.length % 2 === 0)) {
                //we have an even number
                coordLen = coords.length / 2;
                easting = parseFloat(coords.substring(0, coordLen));
                northing = parseFloat(coords.substring(coordLen));

                if (isNaN(easting) || isNaN(northing)) {
                    //not both numbers
                    isValid = false;
                    this.invalidGridRef.style.display = 'block';
                    return;
                }
                //all ok we sholud have a sheet number and two coords
                eastingStr = coords.substring(0, coordLen);
                northingStr = coords.substring(coordLen);
            }
            else {
                //not an even number
                isValid = false;
                this.invalidGridRef.style.display = 'block';
                return;
            }

        } else {
            //no sheet number, parse the string one character at time use the first non numeric as the seperator
            sheet = null;
            coords = searchTerm;

            for (let i = 0; i < coords.length; i++) {
                char = String.fromCharCode(coords.charCodeAt(i));

                if (!isNaN(parseInt(char))) {
                    //char is a number
                    if (!processNorthing) {
                        eastingStr += char;

                    } else {
                        northingStr += char;
                    }

                } else {
                    //char is not a number, so we treat as a seperator, unless we already have a value in the northing in which case this is an error
                    if (northing !== null) {
                        isValid = false;
                        this.invalidGridRef.style.display = 'block';
                        return;

                    } else {
                        processNorthing = true;
                    }
                }
            }
            if (isValid && eastingStr.length !== northingStr.length) {
                isValid = false;
                this.invalidGridRef.style.display = 'block';
                return;
            }
        }

        if (isValid) {
            this.centreOnGridRef(sheet, eastingStr, northingStr);

        } else {
            this.invalidGridRef.style.display = 'block';
        }
    }

    private centreOnGridRef = (sheet_number: string, easting: string, northing: string): string => {
        let gridRef:string;

        if (sheet_number && easting && northing) {
            let E: string = easting;
            let N: string = northing;
            //E & N must have same no. of chars
            let ELen: number = easting.length;
            let NLen: number = northing.length;
            if (ELen !== NLen) {
                //error
                this.invalidGridRef.style.display = 'block';
                return;
            }
            else {
                //pad to five char with zeros on right
                for (let i = 0; i < 5 - ELen; i++) {
                    E = E + '0';
                    N = N + '0';
                }
                let osgb: OSGB = new OSGB();
                gridRef = sheet_number + easting + northing;
                if (osgb.ParseGridRef(gridRef) === true) {
                    //console.log('parsed ok');
                    //console.log(self.map.options.dataProjection);
                    let center: Coordinate = [osgb.Eastings, osgb.Northings];

                    let coords3857: Coordinate = olProj.transform(center, 'EPSG:27700', 'EPSG:3857');
                    this.map.getView().animate({ center: coords3857 }, { zoom: 14 });
                }
                else {
                    this.invalidGridRef.style.display = 'block';
                    return;
                }
            }
        } else if (!sheet_number && easting && northing) {
            //no sheet number just a coordinate pair
            let coords: Coordinate = [parseFloat(easting), parseFloat(northing)];
            let coords3857: Coordinate = olProj.transform(coords, 'EPSG:27700', 'EPSG:3857');
            this.map.getView().animate({ center: coords3857 }, { zoom: 14 });
        }

    }

    //function moveTo(easting, northing){
    //    if (map.getView().getProjection().getCode() !== map.options.dataProjection) {
    //        let coord = ol.proj.transform([easting, northing], map.options.dataProjection, map.getView().getProjection().getCode());
    //        easting = coord[0];
    //        northing = coord[1];
    //    }

    //    map.getView().animate({ center: [easting, northing] });

    //    map.contextMenu.addMarker([easting, northing]);
    //}

    public getGridRef = (coordinate: Coordinate): string => {
        //console.log(coordinate);
        let osgb = new OSGB();
        osgb.SetGridCoordinates(coordinate[0], coordinate[1]);
        return osgb.GetGridRef(4);
    }

    public centreMapOnGridRef = (gridRef: string, zoomLevel: number): void =>{
        let osgb: OSGB = new OSGB();
        if (osgb.ParseGridRef(gridRef)) {
            let wgs84:WGS84 = osgb.GetWGS84();
            let coord: Coordinate = olProj.transform([wgs84.Longitude, wgs84.Latitude], 'EPSG:4326', 'EPSG:900913');

            this.map.getView().setCenter(coord);
            if (zoomLevel) {
                this.map.getView().setZoom(zoomLevel);
            }
        }
    }

    public get4326CoordinatesFromGridRef = (gridRef: string): Coordinate => {
        let coord4326: Coordinate;
        let osgb: OSGB= new OSGB();

        if (osgb.ParseGridRef(gridRef)) {
            let wgs84: WGS84 = osgb.GetWGS84();
            coord4326 = olProj.transform([wgs84.Longitude, wgs84.Latitude], 'EPSG:4326', 'EPSG:900913');
        }

        return coord4326;
    }

    public isValidGridRef = (gridRef: string): boolean => {
        let osgb:OSGB = new OSGB();
        return osgb.ParseGridRef(gridRef);
    }



}